export const types = {
  RESET_PASSWORD: 'auth/resetPassword/RESET_PASSWORD',
  RESET_PASSWORD_REQUEST: 'auth/resetPassword/RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'auth/resetPassword/RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_ERROR: 'auth/resetPassword/RESET_PASSWORD_ERROR',
};

export const resetPassword = {
  /**
   * @param {string} data.email
   */
  request: (data) => ({
    type: types.RESET_PASSWORD_REQUEST,
    payload: { data },
  }),
  /**
   * @param {string} message
   */
  success: (message) => ({
    type: types.RESET_PASSWORD_SUCCESS,
    payload: { message },
  }),
  error: (error) => ({
    type: types.RESET_PASSWORD_ERROR,
    payload: error,
  }),
};
